import { render, staticRenderFns } from "./LineTextAreaExWarning.vue?vue&type=template&id=4635e260&"
import script from "./LineTextAreaExWarning.vue?vue&type=script&lang=ts&"
export * from "./LineTextAreaExWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports